var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25H12M8.25 5.25H12M6.75 11.25H9.375M14.25 8.25V5.85C14.25 4.58988 14.25 3.95982 14.0048 3.47852C13.789 3.05516 13.4448 2.71095 13.0215 2.49524C12.5402 2.25 11.9101 2.25 10.65 2.25H7.35C6.08988 2.25 5.45982 2.25 4.97852 2.49524C4.55516 2.71095 4.21095 3.05516 3.99524 3.47852C3.75 3.95982 3.75 4.58988 3.75 5.85V15.75L5.39062 14.25L7.35937 15.75L9 14.25L10.6406 15.75",
    stroke: "#152B35",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.4075C16.4488 11.4106 16.3018 11.4075 16.25 11.4075C15.4816 11.4075 14.7807 11.0643 14.25 10.5C13.7192 11.0643 13.0183 11.4074 12.25 11.4074C12.1982 11.4074 12.0513 11.4106 12.0001 11.4075C12.0001 11.4075 12 11.9891 12 12.2984C12 13.959 12.9561 15.3544 14.25 15.75C15.5439 15.3544 16.5 13.959 16.5 12.2984C16.5 11.9891 16.5 11.4075 16.5 11.4075Z",
    stroke: "#152B35",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.b2abf571812c76c92f3aa869632716cc.svg";
export { ForwardRef as ReactComponent };